import React from "react";
import TableSearch from "./table-search";
import TableSort from "./table-sort";
import TablePagination from "./table-pagination";
import PageSizeSelect from "./page-size-select";
import * as ToggleGroup from "@radix-ui/react-toggle-group";
const toggleGroupItemClasses =
  "flex size-[30px] text-xs px-2 w-full items-center justify-center bg-borderColor text-white first:rounded-l-md last:rounded-r-md hover:bg-primary focus:z-10  data-[state=on]:bg-primary";

const TableHeaders = ({
  searchByOptions,
  onSearchChange,
  sortByOptions,
  onSortChange,
  page,
  onPageChange,
  lastPage,
  pageSizeOptions,
  onPageSizeChange,
  defaultPageSize,
  showPublishedFilter = false,
  onPublishedFilterChange,
  currentPublishedFilterValue,
}: any) => {
  return (
    <div className="w-full flex flex-col gap-y-3 lg:gap-y-0 lg:flex-row my-2 justify-between">
      <div className="flex flex-col gap-y-2 w-full lg:w-1/2 2xl:w-1/3">
        <TableSearch
          searchByOptions={searchByOptions}
          onSearchChange={onSearchChange}
        />

        {showPublishedFilter && (
          <div className="flex items-center space-x-2">
            <ToggleGroup.Root
              className="inline-flex space-x-px rounded-md bg-borderColor"
              type="single"
              defaultValue={currentPublishedFilterValue}
              onValueChange={onPublishedFilterChange}
            >
              <ToggleGroup.Item
                className={toggleGroupItemClasses}
                value="all"
                title="All entries"
              >
                All
              </ToggleGroup.Item>

              <ToggleGroup.Item
                className={toggleGroupItemClasses}
                value="published"
                title="published entries"
              >
                Published
              </ToggleGroup.Item>

              <ToggleGroup.Item
                className={toggleGroupItemClasses}
                value="unpublished"
                title="unpublished entries"
              >
                Unpublished
              </ToggleGroup.Item>
            </ToggleGroup.Root>
          </div>
        )}
      </div>

      <div className="flex w-full h-full lg:w-1/2 2xl:w-1/3 gap-x-3">
        <TableSort sortByOptions={sortByOptions} onSortChange={onSortChange} />

        <TablePagination
          page={page}
          onPageChange={onPageChange}
          lastPage={lastPage}
        />

        {pageSizeOptions && onPageSizeChange && defaultPageSize && (
          <PageSizeSelect
            pageSizeOptions={pageSizeOptions}
            onPageSizeChange={onPageSizeChange}
            defaultPageSize={defaultPageSize}
          />
        )}
      </div>
    </div>
  );
};

export default TableHeaders;
